import { useSelector } from 'react-redux'

import ReadMore from '@/components/PDP/ReadMore'

import SectionsList from './SectionsList'
const TABLE_OF_CONTENTS = 'table-of-contents'

const READ_MORE_LIMIT = 24

const PanelContent = () => {
  const sections = useSelector(state => state.asset.tableOfContents.response)

  return (
    <div className='col-sm-12 p-0'>
      <section className={TABLE_OF_CONTENTS}>
        <ReadMore
          hasReadMore={sections.length > READ_MORE_LIMIT}
          target={TABLE_OF_CONTENTS}
        >
          <SectionsList readMoreLimit={READ_MORE_LIMIT} sections={sections} />
        </ReadMore>
      </section>
    </div>
  )
}

export default PanelContent
